export const getNavObj = ({uvId, uiId}) => {
    const pathName = '/FormilyPreview'
    let urlParams = new URLSearchParams(location.search);

    if(uvId) {
      urlParams.set('uvId', uvId);
      urlParams.delete('uiId')
    }else {
      urlParams.set('uiId', uiId);
      urlParams.delete('uvId')
    }
    
    return {
        pathName,
        search: urlParams.toString()
    }
}

// 对Menu的数据进行处理，将除了label、key之外的值放入custom，并对可能存在的chilren做递归处理
export const processItem = ({ label, key, children, disabled=false, ...otherItem }) => {
    const item = { key, label, disabled, custom: { ...otherItem, label: label } };
    if (children) {
      item.children = children.map(processItem); // 递归处理子节点
    }
    return item;
  };

// 根据Menu当前点击的key的值，查找menuItems里对应的值，考虑children的可能性
export const findMenuItem = (items, key) => {
    for (const item of items) {
      if (item.key === key) return item
      if (item.children) {
        const found = findMenuItem(item.children, key)
        if (found) return found
      }
    }
    return null
}

export const findFirstUI = (root) => {
  // 使用栈实现深度优先搜索
  const stack = [...(root.children || []).slice().reverse()]; 

  while (stack.length > 0) {
    const node = stack.pop();
    
    // 命中目标立即返回
    if (node.type === 'UI') return node;
    
    // 子节点按逆序入栈（保证遍历顺序）
    if (node.children?.length) {
      stack.push(...node.children.slice().reverse());
    }
  }

  return null; // 未找到返回null
}

// 数据扁平化处理
export function flattenArray(data) {
  const result = [];
  data.forEach(item => {
    // 复制当前项的所有属性（排除children）
    const { children, ...rest } = item;
    result.push(rest); // 将当前项加入结果
    if (children && children.length) {
      result.push(...flattenArray(children)); // 递归处理children
    }
  });
  return result;
}

export function markLastOfType(arr) { 
  let lastOccurrence = new Map();

  // 创建一个Map来存储每个type的标记状态
  const typeMap = new Map();
 
  arr.forEach((item, index) => {
    const type = item.sceneNo;
     if (!lastOccurrence.has(type)) {
        lastOccurrence.set(type, index);
    } else {
        lastOccurrence.set(type, index); // 更新为当前位置
    }
    if (!typeMap.has(type)) {
      // 如果这个type还没有被标记，标记它并设置showType = 1
      item.isFirstScene = true;
      typeMap.set(type, true); // 设置这个type为已标记
    }
  });
 
  // 第二次遍历，将每种type的最后一个元素的showType设为1
  arr.forEach((item, index) => {
      if (lastOccurrence.get(item.sceneNo) === index) {
          item.isLastScene = true; // 如果是该type的最后一个元素，则设置showType为1
      }
  });

  return arr;
}


/**
 * 根据uvId查找第一层节点的key
 * @param {Array} data - 树形数据
 * @param {string} uvId - 要查找的uvId
 * @returns {string|null} - 找到的key，如果没有找到，则返回null
 */
export function findFirstLevelKeyByUvId(data, uvId) {
    // 查找包含指定uvId的第一层节点
    const firstLevelItem = data.find(item => 
        hasUvIdInChildren(item.children, uvId)
    );
    
    return firstLevelItem ? firstLevelItem.key : null;
    
    // 辅助函数：检查子孙节点中是否包含指定的uvId
    function hasUvIdInChildren(children, targetUvId) {
        if (!children) return false;
        
        return children.some(child => {
          // console.log(targetUvId)
            // 如果是UI节点且uvId匹配，返回true
            if (child.key == targetUvId) {
                return true;
            }
            // 递归检查子节点
            return hasUvIdInChildren(child.children, targetUvId);
        });
    }
}